module.exports = __webpack_public_path__ + "img/logo2.f155fb44.png";